import React from 'react';
import Navbar from '../shared/Navbar';
import DashboardSidebar from '../shared/DashboardSidebar';

/**
 * DashboardLayout - Wrapper component for authenticated pages
 * Provides consistent layout with Navbar and collapsible sidebar
 */
export const DashboardLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="flex">
        <DashboardSidebar />
        <main className="flex-1 p-6 lg:p-8">
          {children}
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
